import firebase from '@/firebase/config'
import 'firebase/firestore'

const db = firebase.firestore()

if (window.location.hostname === 'localhost' && process.env.VUE_APP_USE_EMULATOR === 'true') {
    db.settings({
        host: 'localhost:8080',
        ssl: false,
    })
}

db.dbName = 'operand'

export default db
